import React, { useEffect } from "react";
import PropTypes from "prop-types";

const UserLocationModal = ({ onConfirm, futureShiftActionOptions, futureShiftCount, locationName, title, showModal }) => {
  const [selectedOption, setSelectedOption] = React.useState("");

  useEffect(() => {
    const modalElement = document.getElementById('userLocationModal');
    const resetSelection = () => {
      setSelectedOption(""); 
    };
    $(modalElement).on('hide.bs.modal', resetSelection);
    return () => {
      $(modalElement).off('hide.bs.modal', resetSelection);
    };
  }, []);

  const modalPresent = $('#userLocationModal').length > 0

  const handleConfirm = () => {
    onConfirm(selectedOption, title);
  };

  return(
    <div className="modal fade" id="userLocationModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h1 className="modal-title">{title}</h1>
          </div>
          <div className="modal-body">
            <span className="pink-text">
              Warning: This employee is scheduled for {futureShiftCount} future shifts at {locationName}. Please choose:
            </span>
            <div className="form-group">
              {futureShiftActionOptions.map(([name, value]) => (
                <div key={value} className="radio" style={{ marginLeft: "10px" }}> 
                  <input
                    type="radio"
                    value={value}
                    checked={selectedOption === value}
                    onChange={(e) => setSelectedOption(e.target.value)}
                    id={`future_shift_action_${value}`}
                    style={{ width: "auto", position: "relative", margin: "auto" }}
                  />
                  <label htmlFor={`future_shift_action_${value}`}>{name}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-pink full-width"
              onClick={handleConfirm}
              disabled={!selectedOption}
            >
              {title}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

UserLocationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  futureShiftActionOptions: PropTypes.array.isRequired,
  futureShiftCount: PropTypes.number.isRequired,
  locationName: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default UserLocationModal;
